import ScrollPage, { SectionItem } from "../../Components/ScrollPage/ScrollPage";
import Section from "../../Components/Section/Section";
import CADDesigns from "../../Content/CAD Designs/CADDesigns";
import EngineModeling from "../../Content/EngineModeling/EngineModeling";
import NewGeometries from "../../Content/NewGeometries/NewGeometries";
import ProductsIntro from "../../Content/NewGeometries/ProductsIntro";
import SoftwareData from "../../Content/Software/SoftwareData";

interface ScrollTo {
    index: number;
}

export const Sections: SectionItem[] = [
    { label: "Intro", id: "intro" },
    { label: "Software", id: "software" },
    { label: "CAD", id: "cad" },
    { label: "Modeling", id: "modeling" }
];


const Products: React.FC<ScrollTo> = ({ index }) => (
    <ScrollPage index={index} sections={Sections}>
        <Section section={Sections[0].id}>
            <ProductsIntro />
        </Section>
        <Section section={Sections[1].id}>
            <SoftwareData />
        </Section>
        <Section section={Sections[2].id}>
            <CADDesigns />
        </Section>
        <Section section={Sections[3].id}>
            <EngineModeling />
        </Section>
    </ScrollPage>
);

export default Products;